import React from 'react';

interface FormFieldProps {
  label: string;
  children: React.ReactNode;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({ label, children, className = '' }) => (
  <div className={className}>
    <label className="block text-base sm:text-sm font-medium text-gray-700 dark:text-gray-200 mb-2 sm:mb-1">
      {label}
    </label>
    {children}
  </div>
);